/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface AdminDataWorkOrcidSyncDTO
 */
export interface AdminDataWorkOrcidSyncDTO  {
    /**
     * 
     * @type {number}
     * @memberof AdminDataWorkOrcidSyncDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminDataWorkOrcidSyncDTO
     */
    orcidId?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDataWorkOrcidSyncDTO
     */
    orcidPutCode?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDataWorkOrcidSyncDTO
     */
    orcidVisibility?: string;
}

/**
 * Check if a given object implements the AdminDataWorkOrcidSyncDTO interface.
 */
export function instanceOfAdminDataWorkOrcidSyncDTO(value: object): value is AdminDataWorkOrcidSyncDTO {
    return true;
}

export function AdminDataWorkOrcidSyncDTOFromJSON(json: any): AdminDataWorkOrcidSyncDTO {
    return AdminDataWorkOrcidSyncDTOFromJSONTyped(json, false);
}

export function AdminDataWorkOrcidSyncDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminDataWorkOrcidSyncDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'orcidId': json['orcidId'] == null ? undefined : json['orcidId'],
                  'orcidPutCode': json['orcidPutCode'] == null ? undefined : json['orcidPutCode'],
                  'orcidVisibility': json['orcidVisibility'] == null ? undefined : json['orcidVisibility'],
    };
}

export function AdminDataWorkOrcidSyncDTOToJSON(json: any): AdminDataWorkOrcidSyncDTO {
    return AdminDataWorkOrcidSyncDTOToJSONTyped(json, false);
}

export function AdminDataWorkOrcidSyncDTOToJSONTyped(value?: AdminDataWorkOrcidSyncDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'orcidId': value['orcidId'],
        'orcidPutCode': value['orcidPutCode'],
        'orcidVisibility': value['orcidVisibility'],
    };
}


